import React from 'react'
import { Dialog, DialogProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

const YumDialog = withStyles((theme: Theme) =>
  createStyles({
    container: {
      //alignItems: 'flex-end',
      alignItems: 'center',

      /*'@media (min-width: 992px)': {
        alignItems: 'center',
      },*/

      marginLeft: '15px',
      marginRight: '15px',
    },
    paper: {
      //borderRadius: '24px 24px 0 0',
      paddingBottom: '32px',
      margin: 0,
      borderRadius: '24px',

      /*'@media (min-width: 992px)': {
        borderRadius: '24px',
      },*/

      /*/!* iOS Safari 11.2, Safari 11 *!/
      '@supports (bottom: constant(safe-area-inset-bottom))': {
        paddingBottom: 'calc(constant(safe-area-inset-bottom) + 16px)',
      },

      /!* iOS Safari 11.4+, Safari 11.1+, Chrome 69+, Opera 56+ *!/
      '@supports (bottom: env(safe-area-inset-bottom))': {
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)',
      },*/
    },
  }),
)(({ classes, ...props }: DialogProps) => {
  return <Dialog disableEnforceFocus classes={classes} {...props} />
})

export default YumDialog
